<script setup lang="ts">
  import type { IAccordion } from '@/storyblok/content/Content.types'
  import { marked } from 'marked'

  const props = withDefaults(defineProps<IAccordion>(), { level2n: false })

  const activeItem = ref()

  const showStructuredData = props.blok?.structuredData ?? false
  const content = props.blok?.content ?? []

  if (showStructuredData) {
    const mainEntity = content
      .filter((item) => item.content?.[0]?.component !== 'accordion')
      .map((item) => {
        const answerText = computed(() => marked(item.content?.[0]?.content ?? ''))
        return {
          '@type': 'Question',
          name: item.title,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answerText.value
          }
        }
      })

    if (mainEntity.length) {
      const structuredData = computed(() => ({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity
      }))

      useJsonLd(`accordion-${props.blok._uid}-json-ld`, structuredData)
    }
  }
</script>

<template>
  <UiAccordion
    v-model="activeItem"
    collapsible
  >
    <template
      v-for="item in content"
      :key="item._uid"
    >
      <LazyUiAccordionItem
        :value="`item-${item._uid}`"
        :anchor="item.anchor"
        :level2n="level2n"
      >
        <template #title> {{ item.title }}</template>
        <template #content>
          <template
            v-for="contentItem in item.content"
            :key="`item-content-${contentItem._uid}`"
          >
            <StoryblokComponent
              :blok="contentItem"
              :level2n="!level2n"
            />
          </template>
        </template>
      </LazyUiAccordionItem>
    </template>
  </UiAccordion>
</template>
